import { useEffect, useState, type ReactNode } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard" },
  { to: "/employees", label: "Employees" },
  { to: "/branding", label: "Branding" },
  { to: "/wallet-diagnostics", label: "Wallet Providers" },
  { to: "/audit-log", label: "Audit Log" },
];

export default function Layout({ children }: { children: ReactNode }) {
  const { username, logout } = useAuth();
  const navigate = useNavigate();
  const [dir, setDir] = useState<"ltr" | "rtl">(() => (document.documentElement.dir as "ltr" | "rtl") || "ltr");

  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          Business Card Platform
          <small>Admin Panel</small>
        </div>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            {item.label}
          </NavLink>
        ))}
      </aside>
      <div className="main-content">
        <div className="topbar">
          <div />
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setDir(dir === "ltr" ? "rtl" : "ltr")}>
              {dir === "ltr" ? "العربية / RTL" : "English / LTR"}
            </button>
            <span className="muted">{username}</span>
            <button
              className="btn btn-secondary btn-sm"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
            >
              Logout
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
